import {
  Badge,
  Box,
  Breadcrumbs,
  Group,
  ScrollArea,
  Text,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useEntryContext } from '../../context';
import { Panel, TableHeader } from './styles';
import { t } from 'i18next';
import { TreeProvider, useTreeContext } from '../../../entry-editor/context';
import { ListTree } from '../../../entry-editor/organisms/list-tree';
import { CreateEntryModal } from '../../../entry-editor/organisms/create-entry-modal';
import { Add, Move } from '@morph-mapper/ui';
import { useStore } from '@/store';

const MoveButton = () => {
  const getName = useStore(({ entries: e }) => e.getName);
  const [pointer, moveOut] = useTreeContext((s) => [s.pointer, s.moveOut]);

  return (
    <Group sx={{ marginBottom: '0.8rem' }}>
      {pointer.length > 1 ? (
        <>
          <Move into={false} onClick={moveOut} />
          <Badge radius="sm" color="cyan">
            <Breadcrumbs separator="/">
              {pointer.slice(1).map((p) => (
                <span key={p}>{getName(p)}</span>
              ))}
            </Breadcrumbs>
          </Badge>
        </>
      ) : null}
    </Group>
  );
};

export const EnvironmentPanel = () => {
  const declareVariableId = useEntryContext((s) => s.getDeclareVariableId());
  const ensureDeclareVariable = useEntryContext((s) => s.ensureDeclareVariable);
  const [isCreateEntryModalOpen, { open, close }] = useDisclosure(false);

  const handleAdd = (e: React.MouseEvent) => {
    e.stopPropagation();
    ensureDeclareVariable();
    open();
  };

  const header = (
    <TableHeader>
      <Box>
        <Text>{t('panel.environment.title')}</Text>
        <Text size="sm" color="dimmed" weight={400}>
          {t('panel.environment.description')}
        </Text>
      </Box>
      <Box
        component="span"
        onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
        sx={{ display: 'inline-flex', alignItems: 'center' }}
      >
        <Add component="div" onClick={handleAdd} />
      </Box>
    </TableHeader>
  );

  return (
    <Panel>
      <Box>
        {declareVariableId ? (
          <TreeProvider id={declareVariableId}>
            <MoveButton />
            {header}
            <ScrollArea h={500}>
              <ListTree />
            </ScrollArea>
            <CreateEntryModal opened={isCreateEntryModalOpen} close={close} />
          </TreeProvider>
        ) : (
          header
        )}
      </Box>
    </Panel>
  );
};
